<template>
  <div>
    <div class="personal_info">
      <el-form :rules="rules2" ref="userForm" :model="userForm" label-width="130px">
        <el-form-item label="ユーザID" prop="user_name">
          <el-input :disabled="!isEdit" v-model="userForm.user_name" placeholder="ユーザーID"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio :disabled="!isEdit" label="男"></el-radio>
            <el-radio :disabled="!isEdit" label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <!--<el-form-item label="证件号码" prop="id_card">-->
          <!--<el-input :disabled="!isEdit" v-model="userForm.id_card" placeholder="请输入证件号码"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="出生日期" prop="birthday" required>
          <el-date-picker v-model="userForm.birthday" :disabled="!isEdit" type="date" placeholder="日付を選ぶ"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="携帯番号" prop="tel">
          <el-input :disabled="!isEdit" v-model="userForm.tel" placeholder="電話番号"></el-input>
        </el-form-item>
        <el-form-item label="メールアドレス" prop="email">
          <el-input :disabled=true v-model="userForm.email" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="info_btn" id="edit" type="primary" v-show="!isEdit" @click="editUserInfo">設定</el-button>
          <el-button class="info_btn" id="save" type="primary" v-show="isEdit" @click.native.prevent="updateUserInfo">保存
          </el-button>
          <el-button class="info_btn" id="editCancel" v-show="isEdit" @click="cancelUserInfo">キャンセル</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="Ppersonal_info">
      <p class="Ppersonal_infoTop">
        <router-link to="/personal">
          <span><img src="../../assets/images/users/Return.png"></span>
        </router-link>
        <span>個人情報</span>
        <span></span>
      </p>
      <el-form :rules="rules2" ref="userForm" :model="userForm" label-width="100px">
        <el-form-item label="ユーザID" prop="user_name">
          <el-input :disabled="!isEdit" v-model="userForm.user_name" placeholder="ユーザーID"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio :disabled="!isEdit" label="男"></el-radio>
            <el-radio :disabled="!isEdit" label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号码" prop="id_card">
          <el-input :disabled="!isEdit" v-model="userForm.id_card" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday" required>
          <el-date-picker align="center" v-model="userForm.birthday" :disabled="!isEdit" type="date" placeholder="日付を選ぶ"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="携帯番号" prop="tel">
          <el-input :disabled="!isEdit" v-model="userForm.tel" placeholder="電話番号"></el-input>
        </el-form-item>
        <el-form-item label="電子メール" prop="email">
          <el-input :disabled=true v-model="userForm.email" placeholder="電子メール"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="info_btn" id="edit" type="primary" v-show="!isEdit" @click="editUserInfo">設定</el-button>
          <el-button class="info_btn" id="save" type="primary" v-show="isEdit" @click.native.prevent="updateUserInfo">
            セーブ
          </el-button>
          <el-button class="info_btn" id="editCancel" v-show="isEdit" @click="cancelUserInfo">キャンセル</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {getUserInfo, updateUserInfo} from './../../api/interface/users';
  import {bus} from '../../main';
  export default{
    name: "",
    data(){
      var validateName = (rule, value, callback) => {
        var targ = /^[A-Za-z]{6,16}/;
        if (!targ.test(value)) {
          callback(new Error("ユーザー名フォーマットエラー。"));
        }
        callback();
      };
      var validateid = (rule, value, callback) => {
        var targ = /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/;
        if (!targ.test(value)) {
          callback(new Error("番号フォーマットが間違っています。"));
        }
        callback();
      };
      var validateTel = (rule, value, callback) => {
        var targ = /^(070|080|090)[0-9]{8}/;
        if (!targ.test(value)) {
          callback(new Error("番号が間違っています。"));
        }
        callback();
      };
      return {
        isEdit: false,
        userForm: {
          user_id: "",
          user_name: "",
          sex: "",
//          id_card: "",
          birthday: "",
          tel: "",
          email: "",
        },
        head_url: localStorage.getItem('headImg') || "",
        token: localStorage.getItem('token') || 0,
        userInfo: {},
        rules2: {
          user_name: [
            {required: true, message: 'ユーザーIDを入力してください', trigger: 'blur'},
            {validator: validateName, trigger: 'blur'}
          ],
//          id_card: [
//            {required: true, message: '証明書の番号は空っぽではありません。', trigger: 'blur'},
//            {validator: validateid, trigger: 'blur'}
//          ],
          birthday: [
            {required: true, message: '日付を選択してください', trigger: 'change'}
          ],
          tel: [
            {required: true, message: '携帯電話番号は空いていない。', trigger: 'blur'},
            {validator: validateTel, trigger: 'blur'}
          ],
          email: [
            {required: true, message: '電子メールは空ではない。', trigger: 'blur'},
          ],
          sex: [
            {required: true, message: '性別を選択してください', trigger: 'change'}
          ]
        },
      }
    },
    beforeMount(){
      if (this.token) {
        this.getUserInfo();
      }
      this.headUrl();
    },
    methods: {
      editUserInfo(){
        this.isEdit = true;
      },
      //获取用户信息
      getUserInfo(){
        getUserInfo().then(result => {
          if (result.code === 1) {
            this.userInfo = result.resData;
            this.userForm.user_id = this.userInfo.user_id;
            this.userForm.user_name = this.userInfo.user_name;
            this.userForm.sex = this.userInfo.sex;
//            this.userForm.id_card = this.userInfo.id_card;
            this.userForm.birthday = this.userInfo.birthday;
            this.userForm.tel = this.userInfo.tel;
            this.userForm.email = this.userInfo.email;
            this.head_url = this.userInfo.head_url;
            bus.$emit("headImg", this.head_url);
          }
        }).catch(err => {
          if (err.code === 2) {
            console.log(err.message)//参数错误
          } else if (err.code === 5) {
            console.log(err.message);//用户不存在
            this.$router.push({path: "/"})
            localStorage.clear('token');
            localStorage.clear('headImg');
            bus.$emit("headImg", this.head_url);
          }
        })
      },
      //更新用户信息
      updateUserInfo(ev){
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            this.userForm.birthday = this.userForm.birthday.toString().slice(0, 10);
            updateUserInfo(this.userForm).then(result => {
              if (result.code === 1) {
                this.isEdit = false;
                this.userInfo.user_name = this.userForm.user_name;
                this.userInfo.sex = this.userForm.sex;
//                this.userInfo.id_card = this.userForm.id_card;
                this.userInfo.birthday = this.userForm.birthday;
                this.userInfo.tel = this.userForm.tel;
                this.userInfo.email = this.userForm.email;
                this.$message({
                  showClose: true,
                  message: result.message,
                  type: 'success'
                });
              }
            }).catch(err => {
              if (err.code === 2) {
                console.log(err.message)//参数错误
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //取消用户信息
      cancelUserInfo(){
        this.isEdit = false;
        this.userForm.user_name = this.userInfo.user_name;
        this.userForm.sex = this.userInfo.sex;
//        this.userForm.id_card = this.userInfo.id_card;
        this.userForm.birthday = this.userInfo.birthday;
        this.userForm.tel = this.userInfo.tel;
        this.userForm.email = this.userInfo.email;
      },
      headUrl(){
        this.$emit("send", this.head_url)
        console.log(this.$emit("send", this.head_url));
      },
    },
    components: {}
  }

</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .personal_info {
      display: none;
    }
    .Ppersonal_info {
      width: 100%;
      /*<!--background-color: $bgcolor;-->*/
      background-color: white;
      .Ppersonal_infoTop {
        height: 50px;
        background-color: $TitColor;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: $whiteColor;
        span:nth-child(1),
        span:nth-child(3) {
          width: 50px;
          display: inline-block;
          height: 50px;
          img {
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
      .el-form {
        padding: 30/$default-w+rem 0;
        margin-left: 10/$default-w+rem;
        .el-input {
          width: 200/$default-w+rem;
        }
        .info_btn {
          margin-top: 30/$default-w+rem;
        }
        #edit {
          margin-left: 0;
        }
        #save {
          margin-left: 0;
        }
        #editCancel {
          margin-left: 30/$default-w+rem;
        }

      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .personal_info {
      width: 100%;
      padding: 30px 0;
      height: 500px;
      background-color: $bgcolor;
      .el-form {
        .el-input {
          width: 300px;
        }
        .el-form-item {
          width: 100%;
        }
        .info_btn {
          margin-top: 30px;
        }
        #edit {
          margin-left: 0;
        }
        #save {
          margin-left: 0;
        }
        #editCancel {
          margin-left: 30px;
        }

      }
    }
    .Ppersonal_info {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/personal/personal_info.vue